import styles from './lib/Url.css?inline';
import { customElement } from 'solid-element';
import { Url } from './lib/Url';
import { version } from '../package.json';
import { setComponentVersion } from '@formbird/solid-utils';
import { mandatoryStyles } from '@formbird/solid-shared';

const UrlWithStyles = (props: any, { element }: { element: HTMLElement }) => {
  setComponentVersion(element, version);
  return (
    <>
      <style>{styles + mandatoryStyles}</style>
      <Url {...props} />
    </>
  );
};

// Register the custom element
customElement('solid-url', {
  document: undefined,
  template: undefined,
  componentDefinition: undefined,
  fieldValue: '',
  fieldName: '',
  previousFieldValue: '',
  key: 0,
  formParameters: undefined,
}, UrlWithStyles);

// Export the component for testing
export { Url };
